module.exports = __webpack_public_path__ + "img/TOOL_TROLLEY.f03dcda2.jpg";